import { type FC, useContext } from "react";
import { type ListColumnMap, ListComponent } from "../../Forms/DragDrop/ComponentBases/ListComponent";
import { DragDropComponentEmptyContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue } from "../../Forms/DragDrop/ReorderableTableSettings";

const VALUE_STYLE = {
    width: "6em",
};

const COLUMN_DEFINITIONS: ListColumnMap = {
    "current-loyalty": {
        valueStyle: VALUE_STYLE,
    },
    "earned": {
        valueStyle: VALUE_STYLE,
    },
    "spent": {
        valueStyle: VALUE_STYLE,
    },
    "before-sale": {
        valueStyle: VALUE_STYLE,
    },
    "after-sale": {
        valueStyle: VALUE_STYLE,
    },
};

export const ReceiptLoyaltyTableComponent: FC<ComponentOptions> = ({
    value,
    style,
}) => {
    const { loyalty } = useContext(DragDropDataContext) as any;

    const empty = useContext(DragDropComponentEmptyContext);

    if(!hasColumnsValue(value)) {
        return empty;
    }

    return (
        <ListComponent
            columns={COLUMN_DEFINITIONS}
            data={loyalty}
            value={value.columns}
            style={style}
        />
    );
};
